<template>
  <div class="fixed-sidebar">
    <div class="sidebar-container">
     
      <div class="sidebar-item" @click="handleAction('message')">
        <i class="el-icon-chat-dot-round"></i>
        <span>消息</span>
      </div>
      <div class="sidebar-item" @click="handleAction('cart')">
        <div class="cart-icon-wrapper">
          <i class="el-icon-shopping-cart-2"></i>
          <span class="cart-count" v-if="cartCount > 0">{{ cartCount }}</span>
        </div>
        <span>购物车</span>
      </div>
      <div class="sidebar-item" @click="handleAction('service')">
        <i class="el-icon-headset"></i>
        <span>官方客服</span>
      </div>
      <div class="sidebar-item" @click="handleAction('feedback')">
        <i class="el-icon-edit-outline"></i>
        <span>反馈</span>
      </div>
      <div class="sidebar-item back-top" v-show="showBackTop" @click="scrollToTop">
        <i class="el-icon-caret-top"></i>
        <span>顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getCartByUserId } from '@/apis/ProductCard'

export default {
  name: 'FixedSidebar',
  data() {
    return {
      showBackTop: false,
      cartCount: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.getCartCount()
    // 监听购物车更新事件
    this.$root.$on('cart-updated', () => {
      this.getCartCount()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackTop = window.pageYOffset > 300
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    // 获取购物车数量
    getCartCount() {
      const userId = localStorage.getItem('userId')
      if (!userId) {
        this.cartCount = 0
        return
      }
      
      getCartByUserId(parseInt(userId)).then(res => {
        if (res.code === 200 && res.data) {
          const totalCount = res.data.reduce((sum, item) => sum + item.quantity, 0)
          this.cartCount = totalCount
        } else {
          this.cartCount = 0
        }
      }).catch(err => {
        console.error('获取购物车数量失败:', err)
        this.cartCount = 0
      })
    },
    handleAction(type) {
      switch(type) {
        case 'cart':
          this.$router.push('/cart');
          break;
        case 'message':
          this.$message.info('消息功能开发中');
          break;
        case 'service':
          this.$message.info('正在连接官方客服...');
          break;
        case 'feedback':
          this.$message.info('感谢您的反馈');
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fixed-sidebar {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  padding-right: 10px;

  @media screen and (max-width: 1200px) {
    /* 屏幕过小时隐藏右侧侧边栏 */
    display: none;
  }
}

.sidebar-container {
  background: #fff;
  border-radius: 20px 0 0 20px;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  padding: 15px 5px;
  width: 70px;
  border: 1px solid #f0f0f0;
  border-right: none;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #333;
  gap: 4px;

  i {
    font-size: 24px;
    color: #3f456d;
  }

  span {
    font-size: 12px;
    transform: scale(0.9);
    white-space: nowrap;
  }

  &:hover {
    background-color: #f8faff;
    
    i {
      color: #6c7bff;
    }
    
    span {
      color: #6c7bff;
    }
  }

  &.official {
    cursor: default;
    &:hover {
      background: transparent;
      i, span { color: #3f456d; }
    }
  }

  &.back-top {
    border-top: 1px solid #f5f5f5;
    margin-top: 5px;
    color: #999;
    i { color: #999; }
  }
}

.cart-icon-wrapper {
  position: relative;
  display: inline-block;
  
  .cart-count {
    position: absolute;
    top: -8px;
    right: -10px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
    color: #ffffff;
    font-size: 11px;
    font-weight: bold;
    min-width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 10px;
    padding: 0 5px;
    box-shadow: 0 2px 6px rgba(255, 107, 107, 0.4);
    transform: scale(0.9);
    z-index: 10;
  }
}
</style>
